import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CoachService } from "app/services/coach/CoachService";
import { Globals } from "app/globals";
import { AdminService, RaterTypeDto } from "app/services/admin/AdminService";
import { ToastrService } from "ngx-toastr";
import { GridOptions } from 'ag-grid';
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-rater-types-for-modal',
    templateUrl: './rater-types-for-modal.component.html',
    styleUrls: ['./rater-types-for-modal.component.scss']
})
export class RaterTypesForModalComponent implements OnInit {
    @ViewChild('raterTypesForModal', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    parent: any;
    raterTypesData: string[] = [];
    raterTypesDataHeaders: any[];
    gridOptions: GridOptions;
    overlayNoRowsTemplate;

    action: string;
    name: string = '';
    currentRaterId: number;
    raterTypesGridApi;
    canEdit: boolean = false;
    canDelete: boolean = false;
    min: number = 3;
    loading: boolean = true;
    modalPrefix: string;
    isStandard: boolean = false;
    modalIndex: number;

    constructor(
        public _AdminService: AdminService,
        public _CoachService: CoachService,
        public _Globals: Globals,
        public _toastr: ToastrService
    ) {
        this.overlayNoRowsTemplate = '<span>No row to show</span>';
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;
    }

    //=============modal directive================
    show(parent: any, modalIndex): void {
        this.modalIndex = modalIndex;
        this.parent = parent;
        this.modal.show();
        $('#raterTypesForModal').modal({ backdrop: "static" });
        $('#raterTypesForModal').modal('show');
        this.onShown('rtfm');
    }

    onShown(modalPrefix: string): void {
        this.modalPrefix = modalPrefix;
        this.raterTypesDataHeaders = this.createRaterTypesHeaders();
        //this.getRaterTypesByCoach();
        this.getGlobalRaterTypes();
        $('.rater-types-modal li').removeClass('active').eq(0).addClass('active');
        this.isStandard = true;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    close(): void {
        this.modal.hide();
        $('#raterTypesForModal').modal('hide');
    }
    //=============modal directive================

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    getRaterTypesByCoach() {
        this._CoachService.getRaterTypesByCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesByCoach', data);

            this.loading = false;
            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesData);

                setTimeout(() => {
                    this.sizeToFit(this.raterTypesGridApi);
                    this.parent.getRaterTypesForCoach(true); 
                }, 100);

            }
        });
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);
            this.loading = false;
            
            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesData);

                setTimeout(() => {
                    this.sizeToFit(this.raterTypesGridApi);
                }, 100);
            }
        });
    }

    createRaterTypesHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    onRaterTypesRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log(data);
            if (!this.isStandard) {
                this.openModal('Edit', data['Id'], data['Name']); //, data['Min']);
            }       
        }
    }

    openModal(action: string, raterId: number, raterName: string) { //, raterMin: number) {
        if (!this.isStandard) {
            this.action = action;
            this.currentRaterId = raterId;
            this.name = raterName;
            //if (!isUndefined(raterMin)) this.min = raterMin;

            console.log($(`#rtcreateEditModal`));
            $(`.rtfm #rtcreateEditModal`).eq(this.modalIndex).modal({ backdrop: "static" });
            $(`.rtfm #rtcreateEditModal`).eq(this.modalIndex).modal('show');
            //$(`.${this.modalPrefix} #rtcreateEditModal`).modal({ backdrop: "static" });
            //$(`.${this.modalPrefix} #rtcreateEditModal`).modal('show');
        }
    }

    closeModal() {
        $(`.${this.modalPrefix} #rtcreateEditModal`).modal('hide');
        $('#rtcreateEditModal').modal('hide');
    }

    onRaterTypesGridReady(params) {
        this.raterTypesGridApi = params.api;
        //setTimeout(() => {
        //    $(".ag-floating-filter-input").attr("placeholder", "Filter");
        //}, 100);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    /*Confirmation Delete*/

    openConfirmationModal() {
        $(`.rtfm #confirmationDeleteModal`).eq(this.modalIndex).modal({ backdrop: "static" });
        $(`.rtfm #confirmationDeleteModal`).eq(this.modalIndex).modal('show');
    }

    closeModalConfirmation() {
        $(`.${this.modalPrefix} #confirmationDeleteModal`).modal('hide');
    }

    /*DELETE MODAL*/

    deleteRaterType() {
        this._AdminService.postDeleteRaterType(this.currentRaterId).subscribe((data: any) => {
            console.log('response_DeleteRaterType', data.result.Result);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 1:
                        this.getRaterTypesByCoach();
                        this.closeModalConfirmation();
                        this.closeModal();
                        this._toastr.success("Relationship deleted successfully", "ELI");
                        break;
                    case 0:
                        this._toastr.error("We are sorry.  An error happened while trying to delete the relationship", "ELI");
                        break;
                    case -1:
                        this._toastr.warning("This relationship cannot be deleted since it is being used in assessment assignments", "ELI");
                        break;
                }
            }
        });
    }

    //save rater
    saveRaterType() {
        let raterType = new RaterTypeDto;
        raterType.Id = this.currentRaterId;
        raterType.Name = this.name;
        raterType.Min = this.min;
        raterType.IsGlobal = false;

        if (raterType.Name === "") {
            this._toastr.warning("The field name can not be empty.", "ELI");
            return;
        }

        //if (raterType.Min === null || raterType.Min < 0) {
        //    this._toastr.warning("Invalid entry for Min field.", "ELI");
        //    return;
        //}

        this.SaveRaterType(raterType);
    }

    SaveRaterType(raterType: RaterTypeDto) {
        this._AdminService.postSaveRaterType(raterType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('data', data);
                //this.getGlobalRaterTypes();
                this.getRaterTypesByCoach();
                this.closeModal();
            }
        })
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    //loadData
    loadData(type: number) {
        switch (type) {

            case 1:
                this.isStandard = false;
                this.getRaterTypesByCoach();
                break;

            case 2:
                this.isStandard = true;
                this.getGlobalRaterTypes();
                break;
        }   
    }

}
